import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_SUBSCRIPTIONS, CANDIDATE_SUBSCRIPTIONS_HISTORY, CANDIDATE_SUBSCRIPTIONS_PAYMENT, EMPLOYER, EMPLOYER_SUBSCRIPTIONS_HISTORY, EMPLOYER_SUBSCRIPTIONS_PAYMENT } from "../../../common/URLs";


export const fetchCandidateSubscriptions = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SUBSCRIPTIONS}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchCandidateSubscriptionsHistory = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SUBSCRIPTIONS_HISTORY}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchCandidateSubscriptionsPaymentCheck = async (uuid) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SUBSCRIPTIONS_PAYMENT}/${uuid}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};


